export function Loader({ visible }: { visible: boolean }) {
  return <div className={`lds-dual-ring ${!visible ? "lds-dual-ring-hidden": ""}`}></div>;
}
